import React, { useEffect, useRef, useCallback, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {  RootReducer } from "../../../components/app/reducer"
import Disclaimer from "../../../components/disclaimer"
import { SelectCl } from "../../../components/select-cl"
import { InputDateCl } from "../../../components/input-date"
import {InputTaxable} from "../../../components/input-taxable"
import {InputCheckboxList} from "../../../components/input-checkbox-list"
import {fetchSecurities} from "./service"
import { useHistory } from "react-router"
import { InputTextCl } from "../../../components/input-text-cl"


const SecurityCriteria : React.FC = () => {    
    const NBSP = "\u00a0";
    const disclaimerAccepted = useSelector((state:RootReducer) =>  state.appReducer.blnAppDisclaimerAgreed );
    const allDomainsLoaded = useSelector(  (state:RootReducer) => { return state.securityCriteriaReducer.allDomainsLoaded });
    let criteriaOrSearchError = useSelector((state: RootReducer) => { return  state.securityCriteriaReducer.error || state.securityResultReducer.error });     
    const state = useSelector( (state:RootReducer) => state.securityCriteriaReducer );
    const secuSearchDone = useSelector((state:RootReducer) =>  state.securityResultReducer.searchDone );
    const rootDispatch = useDispatch();
    const formRef = useRef(null);
    const history = useHistory();              

    //set reset state
    const[reset, setReset] = useState(0);
    const[disableButton, setDisableButton] = useState(false);
    const[displayLoading, setdisplayLoading] = useState(false);
    
    useEffect( ()=> {
        document.title = "Search for Securities"
    },[])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {                
        if (criteriaOrSearchError){
            setDisableButton(false);
            setdisplayLoading(false);
        } 
    })

    useEffect( () => {
        if ( ! allDomainsLoaded && disclaimerAccepted && !displayLoading){
            console.log("In Security Criteria -> Loading Domains effect")
            rootDispatch({type: "SecurityCriteria/LOADDOMAINS"})
        } else {
            console.log("In Security Criteria -> All domains loaded")
        }
    },[allDomainsLoaded, rootDispatch, disclaimerAccepted, displayLoading])

    useEffect( () => {
        if ( secuSearchDone ) {
            // push new history item == redirect to results page while maintaining the back button function
            history.push("/securityresults")
        }
        // clean-up immediately as without resetting the searchDone the nex render would be adding another history item
        return (()=> {rootDispatch({type:"Security/RESETSEARCH"})})
    }, [secuSearchDone, history, rootDispatch])    


    const onReset = useCallback(() => {   
        rootDispatch({ type: "Security/FETCHERROR", payload: "" })
        rootDispatch({type:"SecurityResult/RESETSEARCH"});
        rootDispatch({type: "SecurityResult/SAVEHISTORY", windowHistoryState: {}});        
        setdisplayLoading(false);
        setReset(reset + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[reset]);
    
    const onSubmitHandle = useCallback(() => {
        if ( formRef.current !== null ) {
            const elmForm = formRef.current as unknown as HTMLFormElement
            const data = new FormData( elmForm )  
            setdisplayLoading(true);
            fetchSecurities(rootDispatch, data, window.history.state)
        }            
        return false;
    },[rootDispatch])


    //
    return (
        <div id="depository-criteria">
                {/* Disclaimer will not render (retruns null) if accepted */}
                <Disclaimer/> 
                
                { disclaimerAccepted && (! allDomainsLoaded || displayLoading ) && ( <> <span>LOADING...</span>   </>) }
                { disclaimerAccepted && criteriaOrSearchError && ( 
                    <div> 
                        <ul >
                            <li className="codelist-header bold">{criteriaOrSearchError}</li>
                        </ul> 
                    </div>) 
                }
                { disclaimerAccepted &&  allDomainsLoaded  && !displayLoading && (
                    <form ref={formRef} onSubmit={(e) => { e.preventDefault(); }}> {/*onSubmitHandle(e) done with onclick - uncontrolled form*/}

                        <p className="codelist-header">Securities Database</p>
    
                        <div className="search-header-info">
                            <p>Please enter your search criteria in the fields below.To search on a range of securities, the wildcard character * may be used in the fields marked with (*). </p>  
                            <p>
                                <span className="bold">Download facilities are available on the next pages.</span>
                            </p>
                        </div>
    
                        <div className="search-control">                                    
                                <span><button disabled = {disableButton} onClick={ onSubmitHandle }>Search</button></span>                                     
                                <span><button disabled = {disableButton} onClick={ onReset }>Reset</button></span>                            
                        </div>
    
                        { (
                             
                            <div className="search-table">                                
                                <InputTextCl 
                                    id="commoncode"
                                    name="cmc"
                                    label="(*) Common Code : "
                                    postlabel={NBSP + "(9 digits - add leading zeroes if necessary)"}
                                    reset={reset}/>  
                                <InputTextCl 
                                    id="isincode" 
                                    name="isin"
                                    label="(*) ISIN : "
                                    reset={reset}/>  
                                <InputTextCl 
                                    id="name" 
                                    name="securityName"
                                    label="(*) Name : "
                                    reset={reset}/>
                                <SelectCl 
                                    id="nomcurr" 
                                    label="Nominal Currency (ISO) : "
                                    name="nomCurr"
                                    options={state.nominalCurrencies} 
                                    reset={reset}/>
                                 <InputTextCl 
                                    id="couprate" 
                                    name="couponRate"
                                    label="(*) Coupon Rate : "
                                    postlabel={NBSP + "(use period as decimal sign)"}
                                    reset={reset}/>
                                <SelectCl
                                    id="secphysform"
                                    label="Security Physical Form : "
                                    name="physicalForm"
                                    options={state.securityPhysForms} 
                                    reset={reset}/>
                                <SelectCl
                                    id="instrcat"
                                    label="Instrument Category : "
                                    name="instrumentCategory"
                                    options={state.instrumentCategories} 
                                    reset={reset}/>    
                                <SelectCl
                                    id="cffflag"
                                    label="CFF Qualified : "
                                    name="cff"
                                    options={state.cffQualified} 
                                    reset={reset}/>   
                                <SelectCl
                                    id="depository"                     
                                    label="Principal Agent / Transfer Agent: "            
                                    name="depCd"                    
                                    options={state.principalTransferAgent} 
                                    reset={reset}/>
                                <SelectCl
                                    id="isinperctry"
                                    label="ISIN listed per ISO country code : "
                                    name="ctry"
                                    options={state.isinPerCtry} 
                                    reset={reset}/>                                
                                <InputCheckboxList
                                    id="csdOfIssuance"
                                    label="CSD of Issuance : "
                                    name="csd"
                                    options={state.csdOfIssuance}  
                                    reset={reset}                                    
                                    csdOfIssuance={true}                                    
                                /> 
                                <InputCheckboxList
                                    id="ismagAdherence"
                                    label="ISMAG Adherence : "
                                    name="ismag"
                                    options={state.IsmagAdherence} 
                                    reset={reset}
                                    />                                                                 
                                <InputDateCl 
                                    id = "onlyIssueExpiring" 
                                    name="expiryBefore" 
                                    label="Only Issues Expiring : " 
                                    interval="before"    
                                    reset={reset}                                                                 
                                    />
                                <InputDateCl 
                                    id="instrumentCreation" 
                                    name="creationDateFrom" 
                                    nameTo="creationDateTo"
                                    label="Instrument Creation Date : " 
                                    interval="fromTo" 
                                    reset={reset}                                 
                                    />
                                <InputDateCl 
                                    id="redenominationDt" 
                                    name="redonominationDateFrom" 
                                    nameTo="redonominationDateTo"
                                    label="Redenomination Date :" 
                                    interval="fromTo"
                                    reset={reset}                                 
                                    />     
                                <InputTaxable
                                    id="taxable"
                                    name="taxable"
                                    label="Taxable : "    
                                    countryOfTax={state.ctryOfTax}                                                                    
                                    taxSpec={state.taxSpecificity}   
                                    reset={reset}                                 
                                    />   
                                <InputDateCl 
                                    id="actualClosingDt" 
                                    name="actualClosingDateFrom" 
                                    nameTo="actualClosingDateTo" 
                                    label="Actual Closing Date : " 
                                    interval="fromTo"
                                    reset={reset}                                 
                                    />                                    
                                <InputDateCl 
                                    id="closingDt" 
                                    name="closingDateTo" 
                                    label="Closing Date : " 
                                    reset={reset}                                 
                                    />                          
                                <SelectCl
                                    id="cbfCustType"
                                    name="cbfCustType"
                                    label="CEU Custody Type : "                                    
                                    options={state.cbfCustodyType} 
                                    reset={reset}
                                    />     
                                <SelectCl
                                    id="ceuAssetsHeldInCbl"
                                    name="ceuAssetsHeldInCbl"
                                    label="CEU assets held via CBL : "                                    
                                    options={state.cffQualified} // This is only Yes/No options - reusing CFF qualified options
                                    reset={reset}
                                    /> 
                                <InputDateCl 
                                    id="t2sCblStartDt" 
                                    name="t2sCblStartDt" 
                                    label="T2S CBL services at CEU Start Date : " 
                                    interval="from"
                                    reset={reset}  
                                     />                                                                                                         
                            </div>
                        )}
                        </form>
                )}
        </div>

			
    )

}


export default SecurityCriteria


